exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-2879a6ce]{margin-bottom:0!important}.form-item[data-v-2879a6ce]{margin-bottom:0}.loader[data-v-2879a6ce]{border-top-color:#ccc!important;-webkit-animation:spinner-data-v-2879a6ce 1.2s linear infinite;animation:spinner-data-v-2879a6ce 1.2s linear infinite}@-webkit-keyframes spinner-data-v-2879a6ce{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes spinner-data-v-2879a6ce{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
